import axios from '../lib/axios';

export const createNote = async (noteData) => {
    // Determine if noteData is FormData or normal JSON object
    const isFormData = noteData instanceof FormData;
    
    const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    
    const { data } = await axios.post('/api/notes', noteData, config);
    return data;
};

export const updateNote = async ({ id, ...noteData }) => {
    const { data } = await axios.put(`/api/notes/${id}`, noteData);
    return data;
};

export const deleteNote = async (id) => {
    const { data } = await axios.delete(`/api/notes/${id}`);
    return data;
};
